import commonModule from "./ko/common";
import userModule from "./ko/user";
import loginModule from "./ko/login";
import registerModule from "./ko/register";
import questionModule from "./ko/question";
import statusModule from "./ko/status";
import codeModule from "./ko/errorCode";
import { storeModule, evaluationModule } from "./ko/store";
import { orderModule } from "./ko/order";
import { homeModule, searchModule } from "./ko/home";
import { otherModule } from "./ko/other";
const kr = {
  commonBox: commonModule,
  loginBox: loginModule,
  registerBox: registerModule,
  questionBox: questionModule,
  //店铺详情
  storeDetail: storeModule,
  //评价部分
  evaluationBox: evaluationModule,
  orderModule: orderModule,
  //首页
  home: homeModule,
  searchModule: searchModule,
  userModule: userModule,
  //状态
  status: statusModule,
  //错误码
  errorCode: codeModule,
  otherModule: otherModule
};
export default kr;
